/**
 * External dependencies
 */
import { useEffect, useRef } from 'react';
import cx from 'classnames';

/**
 * Internal dependencies
 */
import Reveal from '../reveal/reveal';
import Icon from '@/common/icon/icon';

const rules = [
    {
        regex: /^.{8,20}$/,
        label: 'Between 8 to 20 characters',
    },
    {
        regex: /(?=.*[a-z])(?=.*[A-Z])/,
        label: 'Upper and lowercase letters',
    },
    {
        regex: /(?=.*[\d!@#$%^])/,
        label: 'At least 1 number or symbol (such as !@#$%^)',
    },
];

const PasswordInputRules = ({ value, setIsStrictValid }) => {
    const isShownOnce = useRef(false);

    useEffect(() => {
        if (value) {
            isShownOnce.current = true;
        }

        const allRulesValid = rules.every((rule) => rule.regex.test(value));
        setIsStrictValid(allRulesValid);
    }, [value]);

    return (
        <Reveal className="field__rules" show={value || isShownOnce?.current}>
            {rules.map((rule) => {
                const isValid = rule.regex.test(value);

                return (
                    <li
                        key={rule.label}
                        className={cx('field__rule', {
                            'is-valid': isValid,
                        })}
                    >
                        <div className="field__rule-icon">
                            {isValid ? (
                                <Icon name="circle-check" type="solid" color="#318500" />
                            ) : (
                                <Icon name="circle-xmark" type="solid" color="#E51717" />
                            )}
                        </div>

                        <div className="field__rule-label">{rule.label}</div>
                    </li>
                );
            })}
        </Reveal>
    );
};

export default PasswordInputRules;
